export const getFeatureFlagFromStep = (
  featureFlags: {
    name: string;
    value: boolean;
  }[] = [],
  flagName: string
): boolean => featureFlags.some(flag => flag.name === flagName && flag.value);
